@if (allowedActions && ((roleIds && roleIds.length) || templateKey)) {
  @if (!plain) {
    <div class="flex flex-wrap gap-2">
      @for (accessKey of accessList; track $index) {
        @if (allowedActions[accessKey.key]) {
          <p-chip [label]="accessKey.name" styleClass="p-chip-xs text-xs" />
        }
      }
    </div>
  } @else {
    <div [innerHTML]="allowedActionsAsPlain"></div>
  }
} @else {
  <app-alert [canToggle]="false" styleClass="p-3">
    <div class="flex align-items-baseline gap-2">
      <i class="fas fa-circle-info"></i>
      Keine Berechtigungen gesetzt. Aktivieren Sie die Rollen für den aktiven
      Arbeitsbereich links.
    </div>
  </app-alert>
}
